<div class="version-info-panel">
  <h1>Api and Web Dashboard Info / Version details</h1>
  <h2>Api Info</h2>
  <ngx-json-viewer [json]="infoDataApi"></ngx-json-viewer>
  <br />
  <h2>Dashboard Web Info:</h2>
  <ngx-json-viewer [json]="infoDataDashboard"></ngx-json-viewer>
</div>
